import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "@apollo/client";

import Button from "./Button";
import PopUp from "./PopUp";
import PopUpContext from "./PopUp/PopUpContext";
import AuthForm from "@/components/users/AuthForm";
import ResumeUploadForm from "../../resumes/ResumeUploadForm";
import { ME_USER_QUERY } from "@/graphql/queries/users";
import appText from "@/lang/appText";
import { useRouter } from "next/router";

const ApplyPopupBody = () => {
  const { setTitle } = useContext(PopUpContext);
  const { error, loading, data } = useQuery(ME_USER_QUERY);
  const needsResume = data?.me && data.me.resumes.length === 0;

  useEffect(() => {
    if (needsResume) {
      setTitle(appText.messages.resume.upload);
    }
  }, [needsResume, setTitle]);

  if (error) return <p>Something went wrong...</p>;
  if (loading && !data) return <p>Loading...</p>;
  const caption = needsResume
    ? appText.messages.resume.justOneMoreStep
    : appText.messages.application.beforeApplying;
  return (
    <>
      <p>{caption} 😊</p>
      {needsResume ? (
        <ResumeUploadForm
          noredirect
          refetchQueries={[{ query: ME_USER_QUERY }]}
        />
      ) : (
        <AuthForm noredirect refetchQueries={[{ query: ME_USER_QUERY }]} />
      )}
    </>
  );
};

const RegisterToApplyButton = (props) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const needsResume = props.me && props.me.resumes?.length === 0;
  const popUpTitle = needsResume
    ? appText.messages.resume.upload
    : "Create Profile";

  const router = useRouter();
  const { q, location, category } = router.query;

  const isMedical =
    (q && q.toLowerCase().includes("medical")) ||
    (category && category.toLowerCase().includes("medical"));

  if (props.me && props.me.role?.name !== "candidate") return null;

  return (
    <>
      <div>
        <Button
          fullWidth={!props.compact}
          onClick={() => {
            if (props.onApplyFlowStarted) {
              props.onApplyFlowStarted();
            }
            setShowPopUp(true);
          }}
          color={isMedical ? "5" : ""}
          styles={
            props.compact
              ? `height: 40px; font-size: 0.95em; min-width: 148px; border-radius: 8px; float: none; box-shadow: none;`
              : ""
          }
        >
          {appText.messages.application.applyNow}{" "}
          {isMedical ? "🧑🏻‍⚕️" : "😀"}
        </Button>
      </div>

      <PopUp show={showPopUp} changeHandler={setShowPopUp} title={popUpTitle}>
        {showPopUp ? <ApplyPopupBody /> : null}
      </PopUp>
    </>
  );
};

export default RegisterToApplyButton;
